/* eslint-disable jsx-a11y/alt-text */
import React, { } from 'react'
import './EnteteLogin.css';
import { AppBar, Box, Container, Toolbar } from '@mui/material'

/**
 * Composant d'en-tête de l'application.
 *
 * Ce composant affiche un en-tête avec des options de menu et des boutons de déconnexion.
 * Il permet également de basculer entre les affichages de l'interface et de gérer l'état de connexion.
 *
 * @param props - Les propriétés du composant.
 * @param props.connecter - Indique si l'utilisateur est connecté.
 * @param props.setInterfaceNumber - Fonction pour définir le numéro de l'interface actuelle.
 * @param props.setConnecter - Fonction pour définir l'état de connexion de l'utilisateur.
 * @param props.interfaceNumber - Le numéro de l'interface actuellement affichée.
 * @param props.setSwitchAffichage - Fonction pour définir l'état d'affichage du composant.
 * @returns Le composant `Entete`.
 */
export function EnteteLogin() {

  return (

    <AppBar sx={{backgroundColor:'white'}} position="static">
      <Container style={{maxWidth:'unset'}}>
        <Toolbar disableGutters>

          {/* version desktop */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
            <div className='midis-com-container'>
              <p className='Entete-midis'>midis</p>
              <p className='Entete-com'>com</p>
            </div>
          </Box>

          {/* version mobile */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            <div className='midis-com-container'>
              <p className='Entete-midis'>midis</p>
              <p className='Entete-com'>com</p>
            </div>
          </Box>

        </Toolbar>
      </Container>
    </AppBar>

   
  )
}